export default __webpack_public_path__ + "static/media/Believer's Belt of the Aureate.46a1fe76.jpg";